import Cookies from 'js-cookie';
import COOKIES_KEYS from '../../consts/cookiesKeys';
import { nextWeekDate } from '../date';

export const getToken = () => Cookies.get(COOKIES_KEYS.TOKEN);
export const storeToken = (
  token,
  options = { path: '/', expires: nextWeekDate() }
) => {
  try {
    Cookies.set(COOKIES_KEYS.TOKEN, token, {
      ...options,
      expires: new Date(options.expires)
    });
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }
};
export const refreshAccessTokenAndStoreInCookie = res => {
  try {
    if (!res || !res.token) {
      return null;
    }
    Cookies.remove(COOKIES_KEYS.TOKEN);
    storeToken(res.token, res.options);
    return res.token;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return null;
  }
};
